import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSmartProperties } from './useSmartProperties/useSmartProperties';
import { BasePanel } from '../../Panel/BasePanel';
import { jsx as _jsx } from "react/jsx-runtime";
export function SmartPropertiesPanelFooter() {
  const {
    canEnrich,
    onEnrich,
    isLoading
  } = useSmartProperties();
  return /*#__PURE__*/_jsx(BasePanel.Footer, {
    children: /*#__PURE__*/_jsx(BasePanel.FooterActions, {
      alignItems: "center",
      blockSize: "100%",
      flexGrow: 1,
      children: /*#__PURE__*/_jsx(BasePanel.ButtonUsageCheck, {
        action: "SMART_PROPERTY_RUN",
        disabled: !canEnrich,
        isLoading: isLoading,
        numberOfOperations: 1,
        onClick: onEnrich,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartProperties.panel.cta"
        })
      })
    })
  });
}